<div padding class="organizations-popover">
    <div *ngFor="let org of organizations"
         class="organizations-popover--item">
        <strong>{{ org.name }}</strong>
        <span *ngIf="org.title">- {{ org.title }}</span>
        <span *ngIf="org.startDate && org.endDate">{{ humanDate(org.startDate) }} - {{ humanDate(org.endDate) }}</span>
    </div>
</div>
